export * from './users-catalogs';
export * from './data-tables-catalogs';
export * from './notifications-catalogs';
export * from './external-links-catalogs';
export * from './yes-no-catalogs';
export * from './file-extensions-catalogs';
export * from './decimal-places';
export * from './months-catalogs';

export const LOCAL_STORAGE_KEYS = {
  IDLE_SESSION: 'zentric-idle',
  TICKETS_SESSION: 'zentric-tickets',
  REDIRECT_PATH: 'zentric-path',
  WHITE_LABEL_SESSION: 'white-label',
};
